import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class CreateGalleryCard extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Gallery API
                </h1>
                <div>
                <h2 className="main-subheading">
                            pcs.create_gallery_card</h2>
                    <div className="technical-main-content">
                        <p>
                            Creates a card design using the selected image and returns the card image id for
                            this newly generated design and the handback URL used in the PCS designer for the
                            particular product (as set in the administration tool).
                        </p>
                        <p>
                            The final card design will be as though the image had been loaded into the PCS designer
                            with no further manipulation.</p>
                        <div>
                            <h3>
                                Arguments</h3>
                            <ul>
                                <li><b>api_key</b> (Required)
                                    <p>
                                        A valid API key that must be obtained from Thales representing a subscriber/product
                                        combination. This will be the product handover key and is used to determine which
                                        product this new design will be for.</p>
                                </li>
                                <li><b>method</b> (Required)
                                    <p>
                                        pcs.create_gallery_card</p>
                                </li>
                                <li><b>image_id</b>
                                    <p>
                                        The ID value returned from the ‘image tag in the get_category_image_list call. This
                                        is the stock image that will be used for the new card design.</p>
                                </li>
                                <li><b>returnformat</b> (optional)
                                    <p>
                                    The returned object format. It can either be an XML or JSON (case insensitive). If not
                                    specified, the default return value is an XML</p>
                                </li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Example response XML payload</h3>
                            <p>
                                There will be a single SubmissionResult element with a card_image_id attribute and
                                also the handback_url attribute which is the handback URL used for that product
                                in the PCS designer.</p>
                            <pre>
                            &lt;SubmissionResult card_image_id=”abcdefg” handback_url=”http://www.ssgl.com”&gt;
                            </pre>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Error codes</h3>
                            <ul>
                                <li><b>-1 (General error)</b>
                                    <p>
                                        An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                </li>
                                <li><b>1 (Invalid api_key)</b>
                                    <p>
                                        The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                </li>
                                <li><b>2 (Invalid method)</b>
                                    <p>
                                        The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                </li>
                                <li><b>3 (No method specified)</b>
                                    <p>
                                        The required <em>method</em> parameter was not informed.</p>
                                </li>
                                <li><b>9 (Invalid returnformat)</b>
                                    <p>
                                    The returnformat value was not recognized. It can either be
                                    XML or JSON (case insensitive)</p>
                                </li>
                            </ul>
                            <br/>
                        </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/galleryapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CreateGalleryCard;